import Vue from "vue";

export default class CampaignCartItem {

    constructor(campaignId, campaignInternalName) {
        this.campaignId = campaignId
        this.campaignInternalName = campaignInternalName;

        this.influencerCartItems = {};
    }

    containsInfluencerCartItem(influencerId) {
        return this.influencerCartItems.hasOwnProperty(influencerId)
    }

    putInfluencerCartItem(influencerCartItem) {
        Vue.set(this.influencerCartItems, influencerCartItem.influencerId, influencerCartItem)
    }

    getInfluencerCartItem(influencerId) {
        return this.influencerCartItems[influencerId];
    }
}
